module.exports = __webpack_public_path__ + "static/img/message-box-bg.a455113.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/assets/images/message-box-bg.png
// module id = eK2P
// module chunks = 4